<div class="read-only-badge" *ngIf="isReadOnly" >
  <span class="material-symbols-outlined badge-icon">info</span>
  <span class="badge-tooltip">Read-only access — editing is disabled</span>
</div>
